import React from 'react';
import Heading2 from "../Basic/Heading2";

const ProductDescription = ({ productData, setProductData }) => {
  const handleDescriptionChange = (e) => {
    setProductData(prev => ({
      ...prev,
      description: e.target.value
    }));
  };

  return (
    <div className="space-y-6">
      <Heading2 text={'توضیحات کالا'}/>
      <div>
        <textarea
          value={productData.description}
          onChange={handleDescriptionChange}
          rows={12}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="توضیحات کامل محصول را اینجا بنویسید..."
        />
        <p className="text-sm text-gray-500 mt-2">
          توضیحات کامل به مشتریان در انتخاب بهتر کمک می‌کند
        </p>
      </div>
    </div>
  );
};

export default ProductDescription;